import axios from 'axios'

let origin = window.location.origin.split('//')

const axiosApi = axios.create({
  baseURL: "/v3"
})

axiosApi.defaults.headers.common = {
  'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
  Authorization: localStorage.getItem('token'),
  Accept: 'application/json',
  'Content-Type': 'application/json; charset=utf-8'
}

export default axiosApi;
